import { createTheme } from '@mui/material/styles';

const menuTheme = createTheme({
  palette: {
    primary: {
      main: '#E65100',      // Deep orange - more corporate
      light: '#FF8A50',
      dark: '#B23C17',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#455A64',      // Blue grey - professional accent
      light: '#718792',
      dark: '#1C313A',
      contrastText: '#FFF',
    },
    background: {
      default: '#f1f1f1',   // Light grey background
      paper: '#FFFFFF',
    },
    text: {
      primary: '#263238',   // Dark blue-grey
      secondary: '#455A64', // Medium blue-grey
    }
  },
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Arial', sans-serif",
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      letterSpacing: '-0.01em',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1.1rem',
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: '0.95rem',
      letterSpacing: '0.01em',
    },
    subtitle2: {
      fontSize: '0.85rem',
      letterSpacing: '0.01em',
    },
    body1: {
      fontSize: '0.9rem',
      letterSpacing: '0.01em',
    },
    body2: {
      fontSize: '0.8rem',
      letterSpacing: '0.01em',
    },
    button: {
      fontSize: '0.85rem',
      textTransform: 'none',
      fontWeight: 500,
    },
    caption: {
      fontSize: '0.75rem',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '6px',
          padding: '6px 16px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          },
        },
        contained: {
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
        outlined: {
          borderWidth: '1.5px',
          '&:hover': {
            borderWidth: '1.5px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
        elevation1: {
          boxShadow: '0 1px 4px rgba(0, 0, 0, 0.05)',
        },
        elevation2: {
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '6px',
          },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: '6px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '0.9rem',
          paddingTop: '8px',
          paddingBottom: '8px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: '0.75rem',
          height: '24px',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: '1.1rem',
          fontWeight: 500,
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 700,
      md: 1200,
      mdl: 1600,
      lg: 1800,
      xl: 2400,
      fourk: 3400,
    },
  },
});

export default menuTheme;